import {environment} from '../../environments/environment';


export class ApiConfig {
  static secretKeyHeader(): Record<string, string> {
    return {
      'Erp-Secret-Key': environment.erpSecretKey
    };
  }

  static getBaseUrl(service: string, version: string = 'v1', path?: string): string {
    const parsedUrl = new URL(environment.cloudApiUrl);

    let host = parsedUrl.host;

    // inject env for non-prod
    if (environment.environmentMode !== 'prod') {
      host = `${environment.environmentMode}.${host}`;
    }

    let base = `${parsedUrl.protocol}//${host}/${version.replace(/^\/|\/$/g, '')}/${service.replace(/^\/|\/$/g, '')}`;

    if (path) {
      base += `/${path.replace(/^\/|\/$/g, '')}`;
    }

    return base;
  }
}
